import { useContext, useEffect, useMemo, useState } from "react";
import { JourneysContext } from "apps/journeys/context/journeys-context";
import { percentOfStepTasksComplete, countNumberOfTasksInSteps } from "apps/journeys/utils/helpers";
import ProgressBarWithLabel from "components/forms/progress-bar-with-label";

const JourneysTaskTableHeader = () => {
  const { journeySteps, selectedJourney } = useContext(JourneysContext);
  const completionPercentage = useMemo(() => percentOfStepTasksComplete(journeySteps), [journeySteps]);
  const numberOfTasks = useMemo(() => countNumberOfTasksInSteps(journeySteps), [journeySteps]);
  const [isTaskEmpty, setIsTaskEmpty] = useState(true);

  useEffect(() => {
    numberOfTasks ? setIsTaskEmpty(false) : setIsTaskEmpty(true);
  }, [numberOfTasks, setIsTaskEmpty]);

  if (!journeySteps) return null;

  const taskLabel = numberOfTasks === 1 ? "Step" : "Steps";

  return (
    <div>
      {isTaskEmpty ? (
        <div className=" journeys-no-task--header">
          <div>No steps due in {selectedJourney.name} Cadence</div>
          <i className="gt-icon gt-icon-check journeys-no-task-check"></i>
        </div>
      ) : (
        <div className="journeys-task-table--header">
          <div className="journeys-task-table--header--text">
            {numberOfTasks} {taskLabel}
          </div>
          <ProgressBarWithLabel
            title="Progress"
            showPercent={true}
            weight="thin"
            width={100}
            percent={completionPercentage}
            progressColor="#73c166"
          />
        </div>
      )}
    </div>
  );
};

export default JourneysTaskTableHeader;
